<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import DatesFilterWithCustomRange from '@/V2/components/filters/DatesFilterWithCustomRange';

export default {
  components: { DatesFilterWithCustomRange },
  props: {
    analyticsLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onRangeChanged(range) {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          start_date: range.startDate,
          end_date: range.endDate,
        },
      });
    },
  },
};
</script>

<template>
  <dates-filter-with-custom-range
    :params="params"
    data-testid="dates-filter"
    :data-dd-action-name="analyticsLabel"
    @dates-filter-updated="onRangeChanged"
  ></dates-filter-with-custom-range>
</template>
